import { BillingPaymentTerm } from '@zeus/index'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'

const TERMS = [BillingPaymentTerm.MONTHLY, BillingPaymentTerm.UPFRONT]

type Props = {
  value: BillingPaymentTerm
  onChange: (term: BillingPaymentTerm) => void
}

/** Au mois ou l'année d'avance : seule l'échéance change, deux mois offerts à l'année (#352). */
function PaymentTermSwitch({ value, onChange }: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      <div role="group" aria-label={t('billing.term.field')} className="inline-flex w-fit rounded-md border p-0.5" {...tourAnchor('billing.term')}>
        {TERMS.map(term => (
          <Button
            key={term}
            type="button"
            size="sm"
            aria-pressed={value === term}
            variant={value === term ? 'default' : 'ghost'}
            onClick={() => onChange(term)}
          >
            {t(`billing.term.${term}`)}
          </Button>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">{t(`billing.term.${value}.help`)}</p>
    </div>
  )
}

export default PaymentTermSwitch
